import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IPortfolioNewsArticleEntity } from '../../types'
import type { IPortfolioNewsItemDTO } from '../contracts/portfolio-news'
import { portfolioNewsDisplayTitle } from '../portfolio-news-display-title'

export const mapPortfolioNewsItem = (
  dto: IPortfolioNewsItemDTO,
): IPortfolioNewsArticleEntity => ({
  id: dto.id,
  articleName: portfolioNewsDisplayTitle(dto.title),
  company: dto.company_display,
  companyTags: dto.company_tags,
  source: dto.source,
  publishedDisplay: DateAdapter.formatToRelativeTime(dto.published_at),
  publishedAt: dto.published_at,
  summaryBullets: [],
  articleUrl: null,
  emailBody: null,
  contentSource: '',
})
